import React from "react";
// import { FaPlus } from 'react-icons/fa'
// import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next";

const AboutArea = () => {
  const { t } = useTranslation();

  // const industries = t('about-us-industries', { returnObjects: true })

  return (
    <React.Fragment>
      {/* =============== About Area ===============*/}
      <div className="about-area pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 mb-4 mb-lg-0 "
              data-aos="fade-right"
              data-aos-delay="100"
              data-aos-duration="1500"
            >
              <div className="about-thumb-inner">
                <img
                  className="main-img"
                  src="assets/img/about/10.png"
                  alt="img"
                />
              </div>
            </div>
            <div
              className="col-lg-6 "
              data-aos="fade-left"
              data-aos-delay="100"
              data-aos-duration="1500"
            >
              <div className="section-title mb-0">
                <h5 className="content mb-4">{t("about-us-who-we-are")}</h5>
                <div className="row"></div>
                {/* <Link className="btn btn-border-base" to="/about">
                  {t('discover-more')} <FaPlus />
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* =============== About Area ===============*/}
    </React.Fragment>
  );
};

export default AboutArea;
